import React from 'react'
import PropTypes from 'prop-types'

import { MenuIcon, Coin, CoinIcon } from './Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  formatPhoneNumber = (phone) => {
    if (!phone) return ``
    const cleaned = phone.replace(/\D/g, '')
    if (cleaned.length === 11 && (cleaned.startsWith('7') || cleaned.startsWith('8'))) {
      return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9)}`
    }
    return phone
  }

  isRestaurantOpen = (worktime) => {
    if (!worktime) return false
    
    try {
      const [openTime, closeTime] = worktime.split('-')
      const [openHours, openMinutes] = openTime.split(':').map(Number)
      const [closeHours, closeMinutes] = closeTime.split(':').map(Number)
      
      const now = new Date()
      const currentHours = now.getHours()
      const currentMinutes = now.getMinutes()
      
      const currentTotalMinutes = currentHours * 60 + currentMinutes
      const openTotalMinutes = openHours * 60 + openMinutes
      const closeTotalMinutes = closeHours * 60 + closeMinutes
      
      return currentTotalMinutes >= openTotalMinutes && currentTotalMinutes <= closeTotalMinutes
    } catch (error) {
      console.error('Error parsing worktime:', error)
      return false
    }
  }

  render() {
    const { user, restaurant, data, leftMenu, showLocation, bgWhie } = this.props

    // Создаем элементы меню из данных
    const menuItems = data?.menu?.map(item => ({
      key: item.id,
      label: (
        <a href={item.href} style={{ textDecoration: 'none', color: 'inherit' }}>
          {item.pagetitle}
        </a>
      )
    }))

    return (
      <div className='flex items-center justify-between pt-[10px]'>
        <div className='flex gap-[9px] items-center'>
          <div onClick={() => leftMenu()} className={`flex-none w-[40px] h-[40px] rounded-full ${bgWhie ? `bg-[#F6F6F6]` : `bg-white`} flex items-center justify-center cursor-pointer`}>
            <MenuIcon />
          </div>
          <div className='w-[40px] h-[40px]' />
        </div>
        
        <div onClick={() => showLocation()} className='text-center font-manrope text-[14px] text-black font-semibold cursor-pointer'>
          {/*this.formatPhoneNumber(user?.phone)*/}
          {user?.delivery_type == 'delivery' ?
            <>
              {user?.location?.street &&
                <>
                  {`${user?.location?.street}, д ${user?.location?.house}`}
                </>
              }
            </>
          :
            <>{restaurant?.adres}</>
          }
        </div>

        <div className='flex gap-[9px] items-center'>
          <a href={data?.akcii_link} className={`w-[40px] h-[40px] flex items-center justify-center rounded-full ${bgWhie ? `bg-[#F6F6F6]` : `bg-white`}`}>
            <svg
              height="20"
              width="20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.641 8.333H3.308V15c0 2.5.833 3.333 3.333 3.333h6.667c2.5 0 3.333-.833 3.333-3.333V8.333z"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.25"
              />
              <path
                d="M17.916 5.834v.833c0 .917-.441 1.667-1.666 1.667H3.75c-1.275 0-1.667-.75-1.667-1.667v-.833c0-.917.392-1.667 1.667-1.667h12.5c1.225 0 1.666.75 1.666 1.667zM9.7 4.166H5.1a.78.78 0 01.025-1.083L6.308 1.9a.8.8 0 011.125 0L9.7 4.166zM14.89 4.166h-4.6L12.557 1.9a.8.8 0 011.125 0l1.183 1.183c.3.3.308.775.025 1.083z"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.25"
              />
              <path
                d="M7.45 8.333v4.283a.835.835 0 001.292.7l.783-.516a.832.832 0 01.917 0l.742.5a.83.83 0 001.291-.692V8.333H7.45z"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="1.25"
              />
            </svg>
          </a>
          <a href={data?.lk_link} className='flex-none flex items-center justify-center flex-col'>
            <Coin />
            <div className='w-[35px] h-[15px] bg-[#A6DD2F] flex gap-[2px] items-center justify-center rounded-full mt-[-8px] z-10'>
              <div className='text-white text-[10px]'>{user?.coin}</div>
              <CoinIcon />
            </div>
          </a>
        </div>
      </div>
    )
  }
}

Main.defaultProps = {
  bgWhie: false
}

Main.propTypes = {
  user: PropTypes.object,
  restaurant: PropTypes.object,
  data: PropTypes.object,
  leftMenu: PropTypes.func,
  showLocation: PropTypes.func,
  bgWhie: PropTypes.bool
}

export default Main